// @ts-check

/**
 * Federation package identifiers — SSOT.
 *
 * Plain CJS so webpack.config.js (CJS) can require it directly. TypeScript
 * consumers get literal-string narrowing via JSDoc `@type {const}` (the
 * documented JSDoc equivalent of `as const`), so no `require() + cast`
 * shim is needed.
 *
 * Values match the window scope key the container registers under
 * (ModuleFederationPlugin library.name), except three @abax/ui constants that are
 * not scope keys: `ABAX_UI_PACKAGE_ID` (package id), `ABAX_UI_REMOTE_KEY` (webpack
 * remote key) and `ABAX_UI_STYLES_MODULE` (exposed module path).
 */

const ABAX_UI = /** @type {const} */ ('abax_ui');
// The id bloom and federation-config use for the same remote. Compare package ids
// against this, never against the window scope `ABAX_UI`.
const ABAX_UI_PACKAGE_ID = /** @type {const} */ ('@abax/ui');
const CENTRAL_SSO = /** @type {const} */ ('@abax/central/sso');
const MARKETPLACE_UI = /** @type {const} */ ('@abax/central/marketplace-ui');
const ONBOARDING_SUITE = /** @type {const} */ ('@abax/central/onboarding-suite');
const ABAX_UI_STYLES_MODULE = /** @type {const} */ ('./styles');

// Webpack remote key — distinct from the window scope (`ABAX_UI`,
// underscore). Used as the object key under `remotes:` in webpack.config.js
// AND as the literal string in static imports (`import 'abax-ui/styles'`)
// and ambient module declarations (`declare module 'abax-ui/styles'` in
// src/types/extensions/global.d.ts).
//
// Webpack's chunk resolver and TypeScript's ambient-module syntax both
// require literal strings — they cannot read from this constant directly.
// So the SSOT here is documentary AND serves the one site (webpack
// `remotes:`) that CAN consume a computed key. If you rename the remote
// key, grep the codebase for `'abax-ui'` (kebab-case) and update each
// literal to match this constant.
const ABAX_UI_REMOTE_KEY = /** @type {const} */ ('abax-ui');

module.exports = {
  ABAX_UI,
  ABAX_UI_PACKAGE_ID,
  ABAX_UI_REMOTE_KEY,
  CENTRAL_SSO,
  MARKETPLACE_UI,
  ONBOARDING_SUITE,
  ABAX_UI_STYLES_MODULE,
};
